import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const automaticRenewalFilterLabel = () => t({ message: 'Automatic renewal', comment: 'Insights: Automatic renewal filter' });
export function AutomaticRenewalFilter() {
    return <BooleanFilter name="metadataDocumentAutomaticRenewal" label={automaticRenewalFilterLabel()}/>;
}
